export function catchError(error: unknown): void {
	console.log(error); // eslint-disable-line no-console
}
